import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AngularFirestore } from '@angular/fire/firestore';
import { DataService } from '../../data.service';
import {
  PersonAttending,
  NewAppointmentData,
  Booking,
  Person,
} from '../../types';

@Component({
  selector: 'app-new-appointment-dialog',
  templateUrl: 'new-appointment.component.html',
  styleUrls: ['./new-appointment.component.scss'],
})
export class NewAppointmentDialogComponent {
  name = '';
  surname = '';
  email = '';
  people: PersonAttending[] = [];
  selectedPeople: PersonAttending[] = [];
  counter = 0;
  addPeople = false;
  bookingList: Booking[] = [];
  peopleSubscription = false;
  constructor(
    public dialogRef: MatDialogRef<NewAppointmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewAppointmentData,
    public dialog: MatDialog,
    public firestore: AngularFirestore,
    public dataService: DataService
  ) {
    this.firestore
      .collection('bookings', (ref) =>
        ref
          .where('uid', '==', this.data.uid)
          .where('serviceId', '==', this.data.serviceId)
      )
      .valueChanges()
      .subscribe((bookings) => {
        this.bookingList = bookings as Booking[];
        if (!this.peopleSubscription) {
          this.getPeople();
          this.peopleSubscription = true;
        }
      });
  }

  beskikbaarheid() {
    let taken = 0;
    if (
      this.dataService.allBookingsDictionary.hasOwnProperty(this.data.serviceId)
    ) {
      if (
        this.dataService.allBookingsDictionary[
          this.data.serviceId
        ].hasOwnProperty(this.data.serviceId)
      ) {
        taken =
          this.dataService.allBookingsDictionary[this.data.serviceId][
            this.data.venueId
          ];
      }
    }

    const remaining = this.data.venueCapacity - taken;
    return remaining;
  }

  getPeople() {
    this.firestore
      .collection('people', (ref) => ref.where('uid', '==', this.data.uid))
      .valueChanges()
      .subscribe((peopleList) => {
        this.people = [];
        this.counter = 0;
        const peopleData = peopleList as Person[];
        peopleData.length === 0
          ? (this.addPeople = true)
          : (this.addPeople = false);
        peopleData.map((person) => {
          let attending = false;
          this.bookingList.forEach((booking) => {
            if (booking.key === person.key) {
              attending = true;
              this.counter += 1;
            }
          });
          this.people.push({
            ...person,
            title: `${person.name}`,
            attending,
          });
        });
      });
  }

  close(): void {
    this.dialogRef.close();
  }

  edit(person: PersonAttending) {
    console.log(person);
  }

  bespreek() {
    const beskikbaarheid = this.beskikbaarheid();
    if (this.selectedPeople.length - this.bookingList.length > beskikbaarheid) {
      if (beskikbaarheid > 0) {
        return alert(
          'Jammer, daar is net ' + beskikbaarheid + ' plekke beskikbaar.'
        );
      } else {
        return alert('Jammer, daar is geen plekke beskikbaar nie.');
      }
    }
    this.people.forEach((person) => {
      const attending = this.selectedPeople.indexOf(person) > -1;
      const index = this.bookingList.findIndex(
        (booking) => booking.key === person.key
      );
      const booking = this.bookingList[index];
      if (attending && index === -1) {
        const newBooking: Booking = {
          email: person.email,
          surname: person.surname,
          name: person.name,
          serviceId: this.data.serviceId,
          venueDescription: this.data.venueId,
          serviceTime: this.data.serviceTime,
          uid: this.data.uid,
          key: person.key,
          id: '',
          healthScreening: false,
        };
        this.firestore
          .collection('bookings')
          .add(newBooking)
          .then((d) => {
            console.log('Booking added for', person.name);
            this.firestore
              .collection('bookings')
              .doc(d.id)
              .update({ id: d.id });
          });
      }
      if (!attending && index > -1) {
        const doc = this.bookingList[index].id;
        this.firestore
          .collection('bookings')
          .doc(doc)
          .delete()
          .then((d) => {
            console.log('Booking removed for', booking.name);
          });
      }
    });
    return this.close();
  }

  add() {
    if (this.name.length === 0) {
      return alert("Jy moet 'n naam intik");
    }
    if (this.surname.length === 0) {
      return alert("Jy moet 'n van intik");
    }
    if (this.email.length === 0) {
      return alert("Jy moet 'n naam intik");
    }
    return this.firestore
      .collection('people')
      .add({
        uid: this.data.uid,
        email: this.email,
        name: this.name,
        surname: this.surname,
      })
      .then((d) => {
        this.firestore.collection('people').doc(d.id).update({ key: d.id });
      });
  }
}
